// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportLoadingIndicator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import Load from './Izenda.Loading';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import actions from './Izenda.ExportLoadingIndicatorAction';
import localization from 'share/localization/Izenda.Localizer';
import classnames from 'classnames';
import { map } from 'lodash/fp';

const Loading = observer(props => {
  const exportFileName = props.name;
  const exportLabel = props.error
    ? props.isPrinting
      ? localization.getText('COMMON_LABEL_PRINTING_ERROR')
      : localization.getText('COMMON_LABEL_EXPORTING_ERROR')
    : props.isPrinting ? localization.getText('COMMON_LABEL_PRINTING') : localization.getText('COMMON_LABEL_EXPORTING');

  const className = classnames('u_textBold', {
    u_textErrorColor: props.error
  });

  return (
    <div className="Izenda-Export-Loading  u-bgGray u_borderAll u_marginTop">
      <div className={className}>
        <span className="overflow-text u_inlineBlock  u_paddingLeft">{exportLabel}:&nbsp;</span>
        <OverflowText text={exportFileName} tooltip={exportFileName} className="u_inlineBlock Izenda-Report-Name" />
        <div className="Izenda-Remove-Icon">
          <a>
            <span className="icon-cancel" onClick={props.onClose} />
          </a>
        </div>
      </div>
      {props.error ? null : <Load show />}
    </div>
  );
});

@connect(actions)
class ExportLoadingIndicator extends Component {
  static propTypes = {
    loader: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    const { exportLoader, onAddLoading, onRemoveLoading, onUpdateError } = props;
    this.unregister = exportLoader.registerExportLoadingChanged(onAddLoading, onRemoveLoading, onUpdateError);
  }

  componentWillUnmount() {
    this.unregister();
  }

  removeLoading = (key: string) => {
    return () => this.props.onRemoveLoading(key);
  };

  render() {
    const { onRemoveLoading, loaders } = this.props;
    return (
      <div className="Reporting-Export-Loading">
        {map(
          item => (
            <Loading
              error={item.error}
              name={item.name}
              key={item.key}
              isPrinting={item.isPrinting}
              onClose={this.removeLoading(item.key)}
            />
          ),
          loaders
        )}
      </div>
    );
  }
}

export default ExportLoadingIndicator;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ExportLoadingIndicator.js